/*
 * Validate-users.ts
 * Description: Includes the declaration
 * of the functions for validating a user
 */

// Importing variables
import {
    InvalidEmail, EmailRegex, MissingEmail,
    MissingFirstName, MissingLastName, MissingPassword,
    MissingPasswordConf, MissingPhone, PasswordBelowMin,
    PasswordLength, PasswordsMismatch, PhoneInvalid,
    PhoneRegex, TooLongEmail, TooLongFirstName,
    TooLongLastName, TooLongPhone,
} from '@/ts/variables';
// Importing interface
import {User} from '@/ts/auth/validate-register';

/**
 * Validating user data before updating
 *
 * @param {String[]} errors - a list of errors
 * @param {User} userData - user data
 */
export function validateUpdateUser(errors: string[], userData: User) {
    // Validating first name
    if (userData.first_name.length === 0) { errors.push(MissingFirstName); }
    if (userData.first_name.length > 255) { errors.push(TooLongFirstName); }

    // Validating last name
    if (userData.last_name.length === 0) { errors.push(MissingLastName); }
    if (userData.last_name.length > 255) { errors.push(TooLongLastName); }

    // Validating email
    if (userData.email.length === 0) { errors.push(MissingEmail); }
    if (userData.email.length > 255) { errors.push(TooLongEmail); }
    if (!EmailRegex.test(userData.email)) { errors.push(InvalidEmail); }

    // Validating phone
    if (userData.phone.length === 0) { errors.push(MissingPhone); }
    if (!PhoneRegex.test(userData.phone)) { errors.push(PhoneInvalid); }
    if (userData.phone.length > 255) { errors.push(TooLongPhone); }

    // Validating the new password
    if (userData.password.length > 0) {
        if (userData.password.length < PasswordLength) { errors.push(PasswordBelowMin); }
        // Validating repeated password
        if (userData.password_confirmation.length === 0) { errors.push(MissingPasswordConf); }
        if (userData.password !== userData.password_confirmation) { errors.push(PasswordsMismatch); }
    }
}

/**
 * Validating user data before creating a user
 *
 * @param {String[]} errors - a list of errors
 * @param {User} userData - user data
 */
export function validateCreateUser(errors: string[], userData: User) {
    // Validating first name
    if (userData.first_name.length === 0) { errors.push(MissingFirstName); }
    if (userData.first_name.length > 255) { errors.push(TooLongFirstName); }

    // Validating last name
    if (userData.last_name.length === 0) { errors.push(MissingLastName); }
    if (userData.last_name.length > 255) { errors.push(TooLongLastName); }

    // Validating email
    if (userData.email.length === 0) { errors.push(MissingEmail); }
    if (userData.email.length > 255) { errors.push(TooLongEmail); }
    if (!EmailRegex.test(userData.email)) { errors.push(InvalidEmail); }

    // Validating phone
    if (userData.phone.length === 0) { errors.push(MissingPhone); }
    if (!PhoneRegex.test(userData.phone)) { errors.push(PhoneInvalid); }
    if (userData.phone.length > 255) { errors.push(TooLongPhone); }

    // Validating password
    if (userData.password.length === 0) { errors.push(MissingPassword); }
    if (userData.password.length < PasswordLength) { errors.push(PasswordBelowMin); }

    // Validating repeated password
    if (userData.password_confirmation.length === 0) { errors.push(MissingPasswordConf); }
    if (userData.password !== userData.password_confirmation) { errors.push(PasswordsMismatch); }
}
